
export const GET_CUSTOMIZE_ORDER = "GET_CUSTOMIZE_ORDER"
export const GET_CUSTOMIZE_ORDER_SUCCESS = "GET_CUSTOMIZE_ORDER_SUCCESS"
export const GET_CUSTOMIZE_ORDER_ERROR = "GET_CUSTOMIZE_ORDER_ERROR"

export const UPDATE_CUSTOMIZE_ORDER = "UPDATE_CUSTOMIZE_ORDER"
export const UPDATE_CUSTOMIZE_ORDER_SUCCESS = "UPDATE_CUSTOMIZE_ORDER_SUCCESS"
export const UPDATE_CUSTOMIZE_ORDER_ERROR = "UPDATE_CUSTOMIZE_ORDER_ERROR"